interface PostPutOptions {
  headers?: { [key: string]: string }
}

class HttpClient {
  private _apiBase: string

  constructor(baseUrl?: string) {
    this._apiBase = baseUrl || process.env.REACT_APP_API_BASE || ''
  }

  public async get(route: string, accessToken: string): Promise<any> {
    let responseData
    const url = this._buildUrl(this._apiBase, route)

    try {
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          'x-functions-key': process.env.REACT_APP_API_FUNCTION_KEY ?? '',
          Authorization: `Bearer ${accessToken}`
        }
      })

      responseData = await response.json()
    } catch (e) {
      console.error(e)
    }

    return responseData
  }

  public async post(
    route: string,
    data: any | FormData = {},
    accessToken: string,
    options: PostPutOptions = {}
  ): Promise<any> {
    let responseData
    const url = this._buildUrl(this._apiBase, route)
    const { headers } = options

    // Fetch needs json stringified, but FormData as-is
    const isMultipartForm = data instanceof FormData
    const body = isMultipartForm ? data : JSON.stringify(data)

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'x-functions-key': process.env.REACT_APP_API_FUNCTION_KEY ?? '',
          ...headers
        },
        body
      })

      responseData = await response.json()
    } catch (e) {
      console.error(e)
    }

    return responseData
  }

  public async put(
    route: string,
    data: any | FormData = {},
    accessToken: string,
    options: PostPutOptions = {}
  ): Promise<any> {
    let responseData
    const url = this._buildUrl(this._apiBase, route)
    const { headers } = options

    // Fetch needs json stringified, but FormData as-is
    const isMultipartForm = data instanceof FormData
    const body = isMultipartForm ? data : JSON.stringify(data)

    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          ...headers
        },
        body
      })

      responseData = await response.json()
    } catch (e) {
      console.error(e)
    }

    return responseData
  }

  private _buildUrl(apiBase: string, route: string): string {
    const fixedRoute = this._ensureRouteBeginsWithForwardSlash(route)
    return apiBase + fixedRoute
  }

  private _ensureRouteBeginsWithForwardSlash(route: string): string {
    const regex = /^\//
    return route.match(regex) === null ? `/${route}` : route
  }
}

/**
 * Can be used to create an instance with a different api url
 * Implement headers when needed
 * @param baseUrl [string] e.g. localhost:7071/api
 */
export const createHttpClient = (baseUrl?: string): HttpClient => {
  return new HttpClient(baseUrl)
}

const defaultHttpClient = createHttpClient()

export default defaultHttpClient
